import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27dc824d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard__sidebar sidebar" }
const _hoisted_2 = { class: "dashboard__nav" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__control",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#filter-kilometers" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__order",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#order" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__user",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#profile-user" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__user",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#users" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__gear",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#cogwheel" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__heart",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#heart" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "sprite-icon icon__logout",
    width: "24",
    height: "24"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#logout" })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_router_link, {
        custom: "",
        to: "/auth/my-carconnex"
      }, {
        default: _withCtx(({ isExactActive }) => [
          _withDirectives((_openBlock(), _createElementBlock("li", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeActivity(_ctx.navItem.welcome))),
            class: _normalizeClass([{ 'is-active': isExactActive }, "dashboard__nav-item"]),
            id: "welcome"
          }, [
            _createVNode(_component_router_link, { to: "/auth/my-carconnex" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ], 2)), [
            [_directive_tippy, {
                        content: _ctx.i18n.t('dashboardSidebar.dashboard'),
                        placement: 'right',
                    }]
          ])
        ]),
        _: 1
      }),
      (_ctx.canShowOrdersPage && !_ctx.isProspect)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            custom: "",
            to: 
                    _ctx.$route.path.includes('/auth/my-carconnex/my-orders/')
                        ? _ctx.$route.path
                        : '/auth/my-carconnex/my-orders/to_approve'
                
          }, {
            default: _withCtx(({ isExactActive }) => [
              _withDirectives((_openBlock(), _createElementBlock("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeActivity(_ctx.navItem.orders))),
                class: _normalizeClass([{
                        'is-active': isExactActive,
                        'new-notify': _ctx.indicators?.my_orders?.showNotificationIndicator,
                    }, "dashboard__nav-item"]),
                id: "orders"
              }, [
                _createVNode(_component_router_link, {
                  to: 
                            _ctx.$route.path.includes('/auth/my-carconnex/my-orders/')
                                ? _ctx.$route.path
                                : '/auth/my-carconnex/my-orders/to_approve'
                        
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["to"])
              ], 2)), [
                [_directive_tippy, {
                        content: _ctx.i18n.t('dashboardSidebar.myOrders'),
                        placement: 'right',
                    }]
              ])
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        custom: "",
        to: "/auth/my-carconnex/my-account"
      }, {
        default: _withCtx(({ isActive }) => [
          _withDirectives((_openBlock(), _createElementBlock("li", {
            class: _normalizeClass([{
                        'is-active': isActive,
                        'new-notify': _ctx.indicators?.my_account?.showNotificationIndicator,
                    }, "dashboard__nav-item"]),
            id: "account"
          }, [
            _createVNode(_component_router_link, { to: "/auth/my-carconnex/my-account" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ], 2)), [
            [_directive_tippy, {
                        content: _ctx.i18n.t('dashboardSidebar.myAccount'),
                        placement: 'right',
                    }]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        custom: "",
        to: "/auth/my-carconnex/my-company"
      }, {
        default: _withCtx(({ isActive }) => [
          _withDirectives((_openBlock(), _createElementBlock("li", {
            class: _normalizeClass([{
                        'is-active': isActive,
                        'new-notify': _ctx.indicators?.my_company?.showNotificationIndicator,
                    }, "dashboard__nav-item"]),
            id: "account"
          }, [
            _createVNode(_component_router_link, { to: "/auth/my-carconnex/my-company" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ], 2)), [
            [_directive_tippy, {
                        content: _ctx.i18n.t('dashboardSidebar.myCompany'),
                        placement: 'right',
                    }]
          ])
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            custom: "",
            to: "/auth/my-carconnex/my-settings"
          }, {
            default: _withCtx(({ isExactActive }) => [
              _withDirectives((_openBlock(), _createElementBlock("li", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeActivity(_ctx.navItem.settings))),
                class: _normalizeClass([{
                        'is-active': isExactActive,
                        'new-notify': _ctx.indicators?.my_settings?.showNotificationIndicator,
                    }, "dashboard__nav-item"]),
                id: "settings"
              }, [
                _createVNode(_component_router_link, { to: "/auth/my-carconnex/my-settings" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ], 2)), [
                [_directive_tippy, {
                        content: _ctx.i18n.t('dashboardSidebar.mySettings'),
                        placement: 'right',
                    }]
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.canShowFavoritesPage)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            custom: "",
            to: "/auth/my-carconnex/my-favorites"
          }, {
            default: _withCtx(({ isExactActive }) => [
              _withDirectives((_openBlock(), _createElementBlock("li", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeActivity(_ctx.navItem.favorites))),
                class: _normalizeClass([{
                        'is-active': isExactActive,
                        'new-notify':
                            _ctx.indicators?.my_favourites?.showNotificationIndicator,
                    }, "dashboard__nav-item"]),
                id: "favorites"
              }, [
                _createVNode(_component_router_link, { to: "/auth/my-carconnex/my-favorites" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ], 2)), [
                [_directive_tippy, {
                        content: _ctx.i18n.t('dashboardSidebar.myFavourites'),
                        placement: 'right',
                    }]
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ctx.logout())),
      class: "dashboard__nav-item --logout"
    }, _hoisted_10)), [
      [_directive_tippy, {
                content: _ctx.i18n.t('dashboardSidebar.logOut'),
                placement: 'right',
            }]
    ])
  ]))
}